import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import * as moment from 'moment';
import { environment } from '../../../../../../environments/environment';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { StaticStampService } from 'app/common/services/StaticStamp.service';

declare var $: any;
declare var Chartist: any;

@Component({
    selector: 'static-report',
    styleUrls: ["style.css"],
    templateUrl: './modalReport.template.html',
})

export class ModalReportComponent implements OnInit {

    public stamp_id: number;
    public FormFilter: FormGroup;
    public tab: number = 3;
    public model: any = {};

    constructor(
        private staticService: StaticStampService,
        private toastr: ToastrService,
        private fb: FormBuilder,
    ) {

    }

    ngOnInit() {
        this.createFormFilter();
        this.changeTime();
    }

    createFormFilter() {
        this.FormFilter = this.fb.group({
            range_date: [null],
        });
    }

    changeTime() {
        let startDate: any = "";
        let endDate: any = "";
    
        switch (this.tab) {
          case 1: {
            startDate = moment();
            endDate = moment();
            break;
          }
          case 2: {
            startDate = moment().startOf("week");
            endDate = moment();
            break;
          }
          case 3: {
            startDate = moment().startOf("month");
            endDate = moment();
            break;
          }
        }
        let options = {
            from : startDate.format('YYYY-MM-DD'),
            to : endDate.format('YYYY-MM-DD'),
        }

        this.loadData(options);
    }

    search(data: any = {}) {
        let options = {
            from: moment(data.range_date[0]).format('YYYY-MM-DD'),
            to: moment(data.range_date[1]).format('YYYY-MM-DD')
        };
        this.loadData(options);
    }


    loadData(request: any = {}) {
        console.log('reee', request);
        let ok = true;
        if(request.from && request.to) {
            let from  = moment(request.from);
            let to  = moment(request.to);
            let days = to.diff(from, 'days')
            if (days >= 90) {
                ok = false;
                this.toastr.warning(
                  "Chỉ được lọc tối đa trong khoảng thời gian 60 ngày",
                  "",
                  {
                    timeOut: 4000,
                    positionClass: "toast-bottom-right"
                  }
                );
              } 
        }
        if(ok) {
            this.staticService.reportScan(this.stamp_id, request).subscribe((res: any) => {
                if (res.error == false) {
                    let data = res.data;
                    let days = [];
                    let labels = [];
                    data.forEach(e => {
                        days.push(e.date)
                        labels.push(e.count);
                    });

                    console.log(days, labels);

                    new Chartist.Line('#statusScan', {
                        labels: days,
                        series: [
                            labels
                        ]
                    }, {
                        fullWidth: true,
                        chartPadding: {
                            right: 40
                        }
                    });

                    this.staticService.reportCity(this.stamp_id, request).subscribe((rs : any) => {
                        if(rs.error == false) {
                            let list = rs.data;
                            let labels = [];
                            let cities = [];
                            list.forEach(e => {
                                labels.push(e.city);
                                cities.push(e.count)
                                
                            });
                            var dataPie = {
                                labels: labels,
                                series: cities
                              };
                              
                              var options = {
                                labelInterpolationFnc: function(value) {
                                  return value[0]
                                }
                              };
                              
                              var responsiveOptions = [
                                ['screen and (min-width: 640px)', {
                                  chartPadding: 30,
                                  labelOffset: 100,
                                  labelDirection: 'explode',
                                  labelInterpolationFnc: function(value) {
                                    return value;
                                  }
                                }],
                                ['screen and (min-width: 1024px)', {
                                  labelOffset: 80,
                                  chartPadding: 20
                                }]
                              ];
                              
                              new Chartist.Pie('#statusCity', dataPie, options, responsiveOptions);
                        }
                    })
                }
            })
        }
        
    }
}




// WEBPACK FOOTER //
// /app/src/app/pages/admin/qrcode/static_stamp/modal/modalReport.component.ts